import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StudentService {

    constructor(private http: CustomHttpService) { }

    getAllStudentsWithCount(data: any): Observable<any> {
        return this.http.post(environment.getAllStudentsWithCount, data);
    }

    moveToStudent(data: any): Observable<any> {
        return this.http.post(environment.moveToStudent, data);
    }

    updateStudent(data: any): Observable<any> {
        return this.http.post(environment.updateStudent, data);
    }

    getStudentById(id: string): Observable<any> {
        return this.http.get(`${environment.getStudentById}/${id}`);
    }

    deleteStudent(id: string): Observable<any> {
        return this.http.delete(`${environment.deleteStudent}/${id}`);
    }

    createStudent(data: any): Observable<any> {
        return this.http.post(environment.createStudent, data);
    }

    updateBulkStudents(data: any): Observable<any> {
        return this.http.post(environment.updateBulkStudents, data);
    }

    createStudentTempProfile(data: any): Observable<any> {
        return this.http.post(environment.createStudentTempProfile, data);
    }


    getStudentTempProfileByUUID(data: any): Observable<any> {
        return this.http.post(environment.getStudentTempProfileByUUID, data);
    }
}
